import React, { useEffect, useRef, useState } from "react";
import StepsTemplate from "../StepsTemplate";

import { useAppDispatch, useAppSelector } from "store";
import { dates, getZodiacSign } from "utils/defaults";
import { setBirthday } from "store/slices/registration";
import DefaultButton from "components/buttons/DefaultButton";
import Flicking, { ViewportSlot } from "@egjs/react-flicking";

import "@egjs/react-flicking/dist/flicking.css";
import "@egjs/react-flicking/dist/flicking-inline.css";
import "./styles.scss";
import { isLeapYear } from "utils/validations";
import { createDateFormat } from "utils/dates";
import { shortMonthMap } from "constants/date";
import ReactGA from "react-ga4";
import ReactPixel from "react-facebook-pixel";

const BirthDaySelect = () => {
  const flickingRef = useRef<any>(null);
  const dispatch = useAppDispatch();

  const userBirthday = useAppSelector(
    (state) => state.registration.birthday?.split("/"),
  );
  console.log("userBirthday", userBirthday);

  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [year, setYear] = useState("");
  const [daysCount, setDaysCount] = useState(31);
  const [dayIndex, setDayIndex] = useState(0);

  const onSelectBirthday = () => {
    ReactGA.event("birthdaySelected");
    ReactPixel.trackCustom("birthdaySelected");
    const date = createDateFormat(month, day, year);
    const zodiac = getZodiacSign(shortMonthMap[month], +day);
    dispatch(
      setBirthday({
        birthday: date,
        zodiac: zodiac.data.zodiacIconUrl,
        zodiacName: zodiac.type,
      }),
    );
  };

  const updateTransform = (e: any) => {
    e.currentTarget.panels.forEach((panel: any) => {
      const rotateVal = -panel.progress * 20;
      const sinRot = Math.sin(Math.abs((rotateVal * Math.PI) / 180));
      const depth = 150 * sinRot * sinRot;

      panel.element.style.transform = `translateZ(-${depth}px) rotateX(${rotateVal}deg)`;
      if (-rotateVal === 0) {
        if (panel.element.textContent.length === 4) {
          if (isLeapYear(panel.element.textContent) && month === "february") {
            if (flickingRef.current) flickingRef.current.moveTo(0);
          }
          setYear(panel.element.textContent);
        } else if (panel.element.textContent.length <= 2) {
          setDay(panel.element.textContent);
          setDayIndex(0);
        } else {
          setMonth(panel.element.textContent?.toLowerCase());
        }
      }
    });
  };

  useEffect(() => {
    if (
      [
        "april",
        "january",
        "march",
        "may",
        "july",
        "august",
        "october",
        "december",
      ].some((el) => el === month)
    ) {
      setDaysCount(31);
    } else if (month === "february") {
      setDaysCount(isLeapYear(+year) ? 29 : 28);
    } else {
      setDaysCount(30);
    }
    if (flickingRef.current) flickingRef.current.moveTo(0);
  }, [month]);

  return (
    <StepsTemplate
      lightTitle="When’s your "
      yellowTitle="Birthday?"
      text="Adding your birthday enriches astrological insights for accuracy and depth."
    >
      <div className="date-demo-wrapper has-text-white position-relative flex mt40">
        <Flicking
          ref={flickingRef}
          defaultIndex={dayIndex}
          className="date-flicking"
          horizontal={false}
          onReady={updateTransform}
          onMove={updateTransform}
        >
          {dates(1, daysCount)}
          <ViewportSlot>
            <div className="shadow-top"></div>
            <div className="shadow-bottom"></div>
          </ViewportSlot>
        </Flicking>
        <Flicking
          className="date-flicking"
          horizontal={false}
          onReady={updateTransform}
          onMove={updateTransform}
          defaultIndex={4}
        >
          <div className="date-panel">January</div>
          <div className="date-panel">February</div>
          <div className="date-panel">March</div>
          <div className="date-panel">April</div>
          <div className="date-panel">May</div>
          <div className="date-panel">June</div>
          <div className="date-panel">July</div>
          <div className="date-panel">August</div>
          <div className="date-panel">September</div>
          <div className="date-panel">October</div>
          <div className="date-panel">November</div>
          <div className="date-panel">December</div>
          <ViewportSlot>
            <div className="shadow-top"></div>
            <div className="shadow-bottom"></div>
          </ViewportSlot>
        </Flicking>
        <Flicking
          defaultIndex={50}
          className="date-flicking"
          horizontal={false}
          onReady={updateTransform}
          onMove={updateTransform}
        >
          {dates(1950, 75)}
          <ViewportSlot>
            <div className="shadow-top"></div>
            <div className="shadow-bottom"></div>
          </ViewportSlot>
        </Flicking>
        <div className="flex position-absolute date-panel-container full-width">
          <div className="date-panel-border" />
        </div>
      </div>
      <div className="bottom-container-absolute">
        <DefaultButton text={"Next"} type="button" onClick={onSelectBirthday} />
      </div>
    </StepsTemplate>
  );
};

export default BirthDaySelect;
